
import React, { useState, useEffect } from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './Contact.css';
import NavBarTop from '../components/NavBarTop';

const Contact = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [form, setForm] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
    // State for FAQ accordion
    const [faqOpen, setFaqOpen] = useState(null);

    const toggleFaq = (index) => {
        setFaqOpen(faqOpen === index ? null : index);
    };

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        alert('Thank you! Your message has been sent.');
        setForm({ name: '', email: '', phone: '', subject: '', message: '' });
    };

    return (
        <div className="mobile-page-container">
            <NavBarTop title="Contact" />

            <div className="container-fluid px-3 pt-4">
                {/* Hero */}
                <div className="text-center mb-4">
                    <h4 className="fw-bold mb-2">We're here to help</h4>
                    <p className="text-muted small">Reach out to us with any questions, feedback, or inquiries.</p>
                </div>

                {/* Contact Methods */}
                <div className="row g-3 mb-4">
                    <div className="col-12">
                        <div className="card border-0 shadow-sm rounded-4 p-3 bg-white text-center">
                            <div className="d-flex align-items-center">
                                <div className="rounded-circle bg-primary-subtle p-3 me-3">
                                    <i className="bi bi-envelope-fill text-primary fs-4"></i>
                                </div>
                                <div className="text-start">
                                    <h6 className="fw-bold mb-1">Email Us</h6>
                                    <a href="mailto:support@physiodirectory.in" className="text-decoration-none text-muted small">support@physiodirectory.in</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="card border-0 shadow-sm rounded-4 p-3 bg-white text-center">
                            <div className="d-flex align-items-center">
                                <div className="rounded-circle bg-success-subtle p-3 me-3">
                                    <i className="bi bi-telephone-fill text-success fs-4"></i>
                                </div>
                                <div className="text-start">
                                    <h6 className="fw-bold mb-1">Call Us</h6>
                                    <p className="mb-0 small text-muted">Mon-Sat, 9AM - 6PM</p>
                                    <a href="tel:+919747444880" className="text-decoration-none text-dark fw-bold small">+91 9947 444 880</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="card border-0 shadow-sm rounded-4 p-3 bg-white text-center">
                            <div className="d-flex align-items-center">
                                <div className="rounded-circle bg-success p-3 me-3 text-white">
                                    <i className="bi bi-whatsapp fs-4"></i>
                                </div>
                                <div className="text-start">
                                    <h6 className="fw-bold mb-1">WhatsApp</h6>
                                    <a href="https://wa.me/919747444880" target="_blank" rel="noreferrer" className="text-decoration-none text-muted small">+91 9947 444 880</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Form */}
                <div className="card border-0 shadow-sm rounded-4 p-4 mb-4 bg-white">
                    <h5 className="fw-bold mb-4">Send Message</h5>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label className="form-label small fw-bold text-muted">Name</label>
                            <input 
                                type="text" 
                                name="name" 
                                className="form-control app-input rounded-pill px-3 py-2"
                                value={form.name}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label small fw-bold text-muted">Email</label>
                            <input 
                                type="email" 
                                name="email" 
                                className="form-control app-input rounded-pill px-3 py-2"
                                value={form.email}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label small fw-bold text-muted">Phone</label>
                            <input 
                                type="tel" 
                                name="phone" 
                                className="form-control app-input rounded-pill px-3 py-2"
                                value={form.phone}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="mb-3">
                             <label className="form-label small fw-bold text-muted">Subject</label>
                             <input 
                                 type="text" 
                                 name="subject" 
                                 className="form-control app-input rounded-pill px-3 py-2"
                                 value={form.subject}
                                 onChange={handleChange}
                                 required
                             />
                        </div>
                        <div className="mb-4">
                            <label className="form-label small fw-bold text-muted">Message</label>
                            <textarea 
                                name="message" 
                                className="form-control app-input rounded-pill px-3 py-2"
                                rows="3"
                                value={form.message}
                                onChange={handleChange}
                                required
                            ></textarea>
                        </div>
                        <button type="submit" className="btn btn-primary w-100 rounded-pill fw-bold">
                            Send Message
                        </button>
                    </form>
                </div>

                {/* FAQ */}
                <h5 className="fw-bold mb-3 ps-1">Common Questions</h5>
                <div className="accordion accordion-flush rounded-4 mb-4 overflow-hidden border-0 shadow-sm" id="accordionFAQ">
                     {[
                        { q: "How do I find a provider?", a: "Use our search filters on the homepage to find providers by location, type, or specialization." },
                        { q: "Are all providers verified?", a: "Yes, all providers undergo a strict verification process." },
                        { q: "How do I become a provider?", a: "Register via the web portal and submit your profile for verification." },
                        { q: "Is the service free for patients?", a: "Yes, browsing and searching for providers is completely free." }
                    ].map((item, idx) => (
                        <div className="accordion-item" key={idx}>
                            <h2 className="accordion-header">
                                <button 
                                    className={`accordion-button ${faqOpen === idx ? '' : 'collapsed'} bg-white small fw-bold py-3`} 
                                    type="button" 
                                    onClick={() => toggleFaq(idx)}
                                >
                                    {item.q}
                                </button>
                            </h2>
                            <div className={`accordion-collapse collapse ${faqOpen === idx ? 'show' : ''}`}>
                                <div className="accordion-body small text-muted bg-light">
                                    {item.a}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Office Location */}
                 <div className="card border-0 shadow-sm rounded-4 p-4 mb-4 bg-white text-center">
                    <div className="mx-auto mb-3 text-primary bg-primary-subtle rounded-circle p-3" style={{width: '60px', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                        <i className="bi bi-geo-alt-fill fs-4"></i>
                    </div>
                    <h5 className="fw-bold mb-2">Visit Our Office</h5>
                    <p className="text-muted small mb-0">
                        Roshni Buildings, Sea View Ward,<br/>
                        Alappuzha – 688012, Kerala, India
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Contact;
